
import { mapState, mapGetters } from 'vuex'
export default {
  props: ['navContext'],
  computed: {
    ...mapState(['env']),
    ...mapState('session', ['user']),
    ...mapGetters(['canAdmin', 'canContrib', 'canAdminDep', 'canContribDep', 'missingSubscription', 'lightPrimary10', 'darkPrimary10']),
    ...mapGetters('session', ['activeAccount']),
    routePrefix () {
      return this.$route && this.$route.name && this.$route.name.split('-')[0]
    },
    style () {
      return `background: linear-gradient(${this.$vuetify.theme.dark ? '90' : '270'}deg,  ${this.lightPrimary10} 0%, ${this.darkPrimary10} 100%);`
    }
  }
}
